import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import { orderBy, has, set, get, split } from 'lodash/fp';
import Pagination from '../../Pagination';
import DateCell from '../../widgets/custom-cell/Date';
import PathKey from '../../widgets/custom-cell/PathKey';
import CustomHeaderCell from '../../widgets/custom-cell/HeaderCell';
import ActionCell from './ActionCell';
import StatusCell from './StatusCell';
import PaginationType from '../../../interfaces/PaginationType';
import DeleteConfirmationModal from '../../DeleteConfirmationModal';

const { Column, Cell, HeaderCell } = Table;

class ROPicklistList extends Component {
  constructor(props) {
    super(props);
    this.state = { showDeleteModal: false, itemToDelete: null };
  }

  componentDidMount() {
    const { onInit } = this.props;
    onInit();
  }

  getData() {
    const { items, query } = this.props;
    const [sortColumn, sortType] = query.order.split(':');
    return orderBy(sortColumn, sortType, items);
  }

  handleSortColumn = (sortColumn, sortType) => {
    const { onSort, query } = this.props;
    onSort(sortColumn, sortType, query);
  };

  handleChangePage = page => {
    const { onChangePage, loadedPages, query } = this.props;
    const isPageLoaded = has(page, loadedPages);
    const nextPageQuery = set('page', page, query);
    onChangePage(nextPageQuery, isPageLoaded);
  };

  handleChangeLimit = limit => {
    const { onChangeLimit, query } = this.props;
    const newQuery = { ...query, limit, page: 1 };
    onChangeLimit(newQuery);
  };

  handleClone = picklist => {
    const { onClone } = this.props;
    onClone(picklist);
  };

  handleHideDeleteModal = () => {
    this.setState({ showDeleteModal: false });
  };

  handleShowDeleteModal = value => {
    this.setState({ showDeleteModal: true, itemToDelete: value });
  };

  handleConfirmDeleteItem = () => {
    const { onDelete } = this.props;
    const { itemToDelete } = this.state;
    onDelete(itemToDelete);
    this.handleHideDeleteModal();
  };

  renderPagination() {
    const { pagination } = this.props;
    return (
      <Pagination
        page={pagination.currentPage}
        limit={pagination.limit}
        total={pagination.totalCount}
        onChangePage={this.handleChangePage}
        onChangeLimit={this.handleChangeLimit}
      />
    );
  }

  render() {
    const { showDeleteModal } = this.state;
    const { isCloning, isFetching, isDeleting, query } = this.props;
    const [sortColumn, sortType] = split(':', get('order', query));

    return (
      <Fragment>
        <Table
          height={420}
          loading={isFetching}
          data={this.getData()}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={this.handleSortColumn}
          bordered
        >
          <Column width={70} sortable resizable>
            <CustomHeaderCell>ID</CustomHeaderCell>
            <Cell dataKey="id" />
          </Column>
          <Column width={150} sortable resizable>
            <CustomHeaderCell>Name</CustomHeaderCell>
            <Cell dataKey="name" />
          </Column>
          <Column width={150} sortable resizable>
            <CustomHeaderCell>Tracking Method</CustomHeaderCell>
            <PathKey dataKey="trackingMethod.label" />
          </Column>
          <Column width={200} resizable>
            <CustomHeaderCell>Description</CustomHeaderCell>
            <Cell dataKey="description" />
          </Column>
          <Column width={200} resizable>
            <CustomHeaderCell>Comment Label</CustomHeaderCell>
            <Cell dataKey="notes" />
          </Column>
          <Column width={80} align="left" sortable>
            <CustomHeaderCell>Priority</CustomHeaderCell>
            <Cell dataKey="position" />
          </Column>
          <Column width={90} align="center" sortable>
            <CustomHeaderCell>Status</CustomHeaderCell>
            <StatusCell dataKey="isVisible" />
          </Column>
          <Column width={120} sortable>
            <CustomHeaderCell>Date Created</CustomHeaderCell>
            <DateCell dataKey="createdAt" />
          </Column>
          <Column width={120} sortable>
            <CustomHeaderCell>Date Updated</CustomHeaderCell>
            <DateCell dataKey="updatedAt" />
          </Column>
          <Column width={180} fixed="right">
            <HeaderCell align="center">Action</HeaderCell>
            <ActionCell
              align="center"
              dataKey="id"
              isCloning={isCloning}
              isDeleting={isDeleting}
              onClone={this.handleClone}
              onDelete={this.handleShowDeleteModal}
            />
          </Column>
        </Table>

        {this.renderPagination()}

        <DeleteConfirmationModal
          message="Are you sure you want to delete this Pick List?"
          show={showDeleteModal}
          onHide={this.handleHideDeleteModal}
          onConfirm={this.handleConfirmDeleteItem}
          isDeleting={isDeleting}
        />
      </Fragment>
    );
  }
}

ROPicklistList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isCloning: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  onInit: PropTypes.func.isRequired,
  query: PropTypes.shape({
    order: PropTypes.string
  }).isRequired,
  loadedPages: PropTypes.shape({}).isRequired,
  pagination: PaginationType.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeLimit: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ROPicklistList;
